import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import zhCN from "ant-design-vue/es/locale/zh_CN"; //引入antd中文包
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { speak, stopSpeech, pauseSpeech, resumeSpeech } from "@/utils/speech";
import { onMounted } from "vue";
import GlobalFloatButton from "@/components/GlobalFloatButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale("zh-cn");

const locale = zhCN;

onMounted(() => {
  speak("欢迎使用轻食易安智能体AI芬拣系统");
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_config_provider, { locale: _unref(locale) }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }, 8, ["locale"]),
    _createVNode(GlobalFloatButton)
  ], 64))
}
}

})